module.exports = __webpack_public_path__ + "img/service.a17fe825.png";